import { ButtonPropType } from './ButtonTypes.d';
import { Button } from './Button';

export { Button, type ButtonPropType };
